import { render, staticRenderFns } from "./pageProjectTitle.vue?vue&type=template&id=5efb4d48&scoped=true"
import script from "./pageProjectTitle.vue?vue&type=script&lang=js"
export * from "./pageProjectTitle.vue?vue&type=script&lang=js"
import style0 from "./pageProjectTitle.vue?vue&type=style&index=0&id=5efb4d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efb4d48",
  null
  
)

export default component.exports